import React, { ReactNode, useContext, useRef } from "react";
import { MsTeamsContext } from "msTeams/store";
import { BoxProps, Card, Divider, Flex, ShorthandValue } from "@fluentui/react-northstar";
import { RegularText } from "shared/components";
import { constants } from "shared/constants";
import { ResizerContext } from "shared/stores/resizeStore/ResizerContext";

export interface ButtonCardProps {
    textLine1?: string | undefined;
    textLine2?: string | undefined;
    onClick: () => void;
    icon: ShorthandValue<BoxProps>;
    appendNodes?: ReactNode;
}

export const ButtonCard: React.FC<ButtonCardProps> = (props) => {
    const resizeContext = useContext(ResizerContext);
    const isMobile = resizeContext.windowWidth < constants.view360MobileDeviceWidthPx;

    const ref = useRef<HTMLDivElement>(null);

    const dividerHeight = React.useMemo(() => {
        if (ref.current) {
            const newHeight = ref.current.offsetHeight * 0.5;
            return newHeight;
        }
    }, [resizeContext.windowWidth, ref.current]);

    return (
        <Card ref={ref} fluid elevated onClick={props.onClick}>
            <Flex gap="gap.small" vAlign="center">
                {props.icon}
                <Divider style={{ height: dividerHeight }} vertical />
                <Flex column={isMobile} wrap>
                    <Flex column styles={{ paddingRight: "8px" }}>
                        {props.textLine1 && <RegularText content={props.textLine1} />}
                        {props.textLine2 && <RegularText content={props.textLine2} />}
                    </Flex>
                    {props.appendNodes && <div style={{ marginTop: "-2px" }}>{props.appendNodes}</div>}
                </Flex>
            </Flex>
        </Card>
    );
};
